export type ActionMap<M extends { [index: string]: any }> = {
    [Key in keyof M]: M[Key] extends undefined
        ? {
              type: Key
          }
        : {
              type: Key
              payload: M[Key]
          }
}

export enum Types {
    Missions_ResetState = "MISSIONS__RESET_STATE",
    Missions_SelectParsedMission = "MISSIONS__SELECT_PARSED_MISSION",
    Missions_SelectMissionId = "MISSIONS__SELECT_MISSION_ID",
    Missions_SelectActiveFlow = "MISSIONS__SELECT_ACTIVE_FLOW",
    Missions_UpdateMissionData = "MISSIONS__UPDATE_MISSION_DATA",
    Missions_UpdateIsVendorFlow = "MISSIONS__UPDATE_IS_VENDOR_FLOW",
    Missions_DeleteMission = "MISSIONS__DELETE_MISSION",
    Missions_DeleteMissionSuccess = "MISSIONS__DELETE_MISSION_SUCCESS",
    Missions_DeleteMissionError = "MISSIONS__DELETE_MISSION_ERROR",
    Missions_FetchParsedMissions = "MISSIONS__FETCH_PARSED_MISSIONS",
    Missions_FetchParsedMissionsSuccess = "MISSIONS__FETCH_PARSED_MISSIONS_SUCCESS",
    Missions_FetchMission = "MISSIONS__FETCH_MISSION",
    Missions_FetchMissionSuccess = "MISSIONS__FETCH_MISSION_SUCCESS",
    Missions_FetchEmployeeList = "MISSIONS__FETCH_EMPLOYEE_LIST",
    Missions_FetchEmployeeListSuccess = "MISSIONS__FETCH_EMPLOYEE_LIST_SUCCESS",
    Missions_FetchVendorNameList = "MISSIONS__FETCH_VENDOR_NAME_LIST",
    Missions_FetchVendorNameListSuccess = "MISSIONS__FETCH_VENDOR_NAME_LIST_SUCCESS",
    Missions_FetchPlatformList = "MISSIONS__FETCH_PLATFORM_LIST",
    Missions_FetchPlatformListSuccess = "MISSIONS__FETCH_PLATFORM_LIST_SUCCESS",
    Missions_FetchAirportList = "MISSIONS__FETCH_AIRPORT_LIST",
    Missions_FetchAirportListSuccess = "MISSIONS__FETCH_AIRPORT_LIST_SUCCESS",
    Missions_UpdateError = "MISSIONS__UPDATE_ERROR",
    Missions_ClearError = "MISSIONS__CLEAR_ERROR",
}
